import { render, staticRenderFns } from "./TopUpDetail.vue?vue&type=template&id=3224644d&scoped=true&"
import script from "./TopUpDetail.vue?vue&type=script&lang=js&"
export * from "./TopUpDetail.vue?vue&type=script&lang=js&"
import style0 from "./TopUpDetail.vue?vue&type=style&index=0&id=3224644d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3224644d",
  null
  
)

export default component.exports